import { Controller } from "@hotwired/stimulus"

// Rotates through predefined quotes with a simple fade every 4s
export default class extends Controller {
  static targets = ["text"]

  connect() {
    this.quotes = [
      "Every login is the start of a new idea.",
      "Big things begin with bold clicks.",
      "Together, we design what’s next.",
      "Collaboration fuels creation.",
      "The future is built by teams like ours.",
      "Pixel by pixel, we craft impact.",
      "Excellence is in the details.",
      "Designing today for tomorrow’s challenges.",
      "Let’s make something amazing.",
      "Ideas grow stronger when shared.",
      "Innovation starts right here.",
      "Predict the future by creating it.",
      "Create. Iterate. Evolve. Together.",
      "Bold design, brighter futures."
    ]

    this.index = 0
    this.intervalMs = 4000 // change cadence stays 4s

    // Show initial
    this.textTarget.textContent = this.quotes[this.index]

    this.timer = setInterval(() => this.next(), this.intervalMs)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  next() {
    this.index = (this.index + 1) % this.quotes.length
    this.fadeTo(this.quotes[this.index])
  }

  fadeTo(newText) {
    this.textTarget.classList.add("opacity-0")
    // After fade-out, swap text and fade-in
    setTimeout(() => {
      this.textTarget.textContent = newText
      this.textTarget.classList.remove("opacity-0")
    }, 420) // match doubled CSS transition duration (~400ms)
  }
}


